const Maintenance = () => {
    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>404 — Website Under Maintenance</h1>
            <p>We are currently performing maintenance. Please try again later.</p>
        </div>
    );
}

export default Maintenance;